import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexEconomicActivitiesRequest = ({
  dispatch,
  params = {},
  failureCallback,
  successCallback
}) =>
  ApiService.request('get', '/economic_activities', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const debounceIndexEconomicActivitiesRequest = AwesomeDebouncePromise(indexEconomicActivitiesRequest, 300);
